import { tns } from 'tiny-slider/src/tiny-slider.module';
import 'tiny-slider/dist/tiny-slider.css';
import './styles/tns_extensions.scss';

// Destroy carousel on this event
// Ref: https://m.phillydevshop.com/turbolinks-5-and-datatables-a882c29d6eff
document.addEventListener('turbolinks:before-cache', () => {
  if (window.qrContainer != null) {
    window.qrContainer.destroy();
    window.qrContainer = null;
  }
});

document.addEventListener('turbolinks:load', () => {
  const qrContainer = document.querySelector('.js-qr-container');
  if (!qrContainer) {
    return;
  }

  const currentIndex = qrContainer.dataset.currentIndex || 0;

  window.voucherContainer = tns({
    container: '.js-qr-container',
    autoplay: false,
    touch: true,
    mouseDrag: true,
    autoplayButton: false,
    loop: false,
    lazyload: true,
    controlsText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
    items: 1,
    edgePadding: 48,
    gutter: 12,
    center: true,
    startIndex: currentIndex
  });
});
